import { lazy, Suspense, useEffect, useRef, useState } from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';

const BelowFoldSections = lazy(() => import('../components/BelowFoldSections'));
const CookieBanner = lazy(() => import('../components/CookieBanner'));
const ScrollToTop = lazy(() => import('../components/ScrollToTop'));

export default function Home() {
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [showBelowFold, setShowBelowFold] = useState(false);
  const [showChrome, setShowChrome] = useState(false);

  useEffect(() => {
    const reveal = () => setShowBelowFold(true);

    window.addEventListener('preload-sections', reveal);
    return () => window.removeEventListener('preload-sections', reveal);
  }, []);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowBelowFold(true);
          observer.disconnect();
        }
      },
      { rootMargin: '280px 0px' },
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const revealChrome = () => setShowChrome(true);

    if ('requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(revealChrome, { timeout: 2500 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(revealChrome, 2500);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar isHomePage={true} />
      <main id="main-content">
        <Hero />
        <div ref={sentinelRef} className="h-px w-full" aria-hidden="true" />
        {showBelowFold && (
          <Suspense fallback={null}>
            <BelowFoldSections />
          </Suspense>
        )}
      </main>
      {showChrome && (
        <Suspense fallback={null}>
          <CookieBanner />
          <ScrollToTop />
        </Suspense>
      )}
    </div>
  );
}
